import { Link } from "react-router-dom";
import { SITE_INFO, categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div>
            <Link to="/" className="flex items-center gap-2" aria-label="漫画岛首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-label text-xl font-bold tracking-wide text-primary-700">漫画岛</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              漫画岛同好讨论社区，聚合漫画评论区、粉丝圈子与书评交流。看完漫画来聊剧情、求推荐，找同好一起追更。
            </p>
          </div>

          {/* 类型导航 */}
          <nav aria-label="漫画分类">
            <h3 className="text-sm font-semibold text-foreground-900">漫画类型</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* 站点导航 */}
          <nav aria-label="站点导航">
            <h3 className="text-sm font-semibold text-foreground-900">站点导航</h3>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">首页</Link>
              </li>
              <li>
                <Link to="/category/reqiu" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">分类书库</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">关于我们</Link>
              </li>
            </ul>
          </nav>

          {/* 联系 */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
                <span>{SITE_INFO.contact}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-600" aria-hidden="true"></i>
                <span>{SITE_INFO.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-primary-600" aria-hidden="true"></i>
                <span>{SITE_INFO.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-center sm:flex-row md:px-6">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {SITE_INFO.name} 版权所有 · 漫画岛同好讨论社区
          </p>
          <p className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="/about" className="hover:text-primary-700">品牌介绍</a>
            <a href={`mailto:${SITE_INFO.contact}`} className="hover:text-primary-700">联系合作</a>
          </p>
        </div>
      </div>
    </footer>
  );
}